import { FormProvider, useForm } from "react-hook-form";
import { FormattedMessage, useIntl } from "react-intl";
import { toast } from "react-toastify";
import { Col, Row } from "react-bootstrap";
import { useParams } from "react-router-dom";
import PropTypes from "prop-types";

import errorToast from "helpers/errorToast";
import Button from "components/atoms/Button/Button";
import Dialog from "components/organisms/Dialog/Dialog";
import { UnassignTeam } from "api";
import testIds from "constants/testIds";
import { IAssignTeam } from "./QuotationType";

interface ReleaseTeamDialogProps {
  isOpen: boolean;
  close: () => void;
  unAssignTeam: IAssignTeam;
  getQuoteRequest: Function;
  refetchAssignedTeams: Function;
  refetchAssignableTeams: Function;
}

function ReleaseTeamDialog(props: ReleaseTeamDialogProps) {
  const { isOpen, close, unAssignTeam, getQuoteRequest, refetchAssignedTeams, refetchAssignableTeams } = props;
  const methods = useForm();
  const intl = useIntl();
  const { id } = useParams();
  const { handleSubmit } = methods;

  const handleReleaseRequest = () => {
    const payload = { team_reference: unAssignTeam?.team_reference };
    UnassignTeam(id, payload)
      .then(() => {
        toast(
          intl.formatMessage({
            id: "quote.unassignSuccessMsg",
            defaultMessage: "Team member unassign successfully",
          }),
          { type: "success" },
        );
        getQuoteRequest();
        refetchAssignedTeams();
        refetchAssignableTeams();
        close();
      })
      .catch((error) => errorToast(error));
  };

  return (
    <Dialog
      size="sm"
      title={
        <FormattedMessage
          id="quote.releaseAssignmentTeamName"
          values={{ name: unAssignTeam?.team_name }}
          defaultMessage="Release assignment"
        />
      }
      show={isOpen}
      onHide={close}
    >
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(handleReleaseRequest)}>
          <div style={{ maxWidth: 474 }}>
            <p className="font-b1">
              <FormattedMessage
                id="quote.sureToReleaseStatment"
                values={{ name: unAssignTeam?.team_name }}
                defaultMessage="Are you sure you want to release assignment?"
              />
            </p>
            <p className="text-secondary font-b1 mt-4">
              <FormattedMessage
                id="quote.quoteWillBeAvailableToAssign"
                defaultMessage="This quote request will be available for all teams within your company and
                team members will be able to assign it to other team and submit quote."
              />
            </p>
          </div>
          <Row className="mt-5">
            <Col lg={12} className="d-flex justify-content-between">
              <Button
                variant="outline-primary"
                label={intl.formatMessage({
                  id: "general.cancel",
                  defaultMessage: "Cancel",
                })}
                size="lg"
                onClick={close}
                data-testid={testIds.SHIPMENT_DASHBOARD_RELEASE_TEAM_MODAL_CLOSE_BUTTON}
              />
              <Button
                variant="primary"
                type="submit"
                size="lg"
                label={intl.formatMessage({ id: "quote.releaseAssignment", defaultMessage: "Release Assignment" })}
                data-testid={testIds.SHIPMENT_DASHBOARD_RELEASE_ASSIGNMENT_BUTTON}
              />
            </Col>
          </Row>
        </form>
      </FormProvider>
    </Dialog>
  );
}

ReleaseTeamDialog.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
  unAssignTeam: PropTypes.instanceOf(Object).isRequired,
};

export default ReleaseTeamDialog;
